import axios from '../../localAxios';
import { workspaceIdURL } from '../workspacesURLs';

interface RenameWorkspaceParam {
  id: string;
  name: string;
}

export async function renameWorkspace({ id, name }: RenameWorkspaceParam) {
  const result = await axios.put(workspaceIdURL(id).href, {
    name,
  });
  return result.data;
}
